import React from 'react';
// components
import Form from '../../../components/Form/Form';
import FieldError from '../../../components/Form/FieldError';
import FormErrors from '../../../components/Form/FormErrors';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';
// utils
import { withFormik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { responseErrors } from '../../../utils/response';
// styles
import styles from '../UserProfileSupport.mod.css';

const SupportInfoForm = ({
  values,
  touched,
  errors = {},
  dirty,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  handleReset,
  color
}) => (
  <Form horizontal onSubmit={handleSubmit}>
    <FormErrors errors={errors} />

    {/* name */}
    <div className="form-control">
      <label className={styles.label} htmlFor="name">
        Name
      </label>
      <div className="field-wrapper">
        <Input
          name="username"
          placeholder={values.username}
          value={values.username}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={errors.username && touched.username}
        />
        <FieldError error={errors.username} touched={touched.username} />
      </div>
    </div>

    {/* email */}
    <div className="form-control">
      <label className={styles.label} htmlFor="email">
        Email
      </label>
      <div className="field-wrapper">
        <Input
          name="email"
          placeholder="example@mail.com"
          value={values.email}
          readOnly
        />
      </div>
    </div>

    <div className={styles['button-section']}>
      <Button type="submit" disabled={isSubmitting} color={color}>
        Save
      </Button>
      <Button
        type="reset"
        link
        onClick={handleReset}
        disabled={!dirty || isSubmitting}
      >
        Discard changes
      </Button>
    </div>
  </Form>
);

export default withFormik({
  mapPropsToValues: ({ user: { username, email } }) => ({
    username: username,
    email: email
  }),
  validationSchema: yup.object().shape({
    username: yup
      .string()
      .nullable()
      .required('Username is required!')
  }),
  handleSubmit: (
    data,
    { setSubmitting, setErrors, props: { onSubmit, user } }
  ) => {
    onSubmit({ id: user.id, data })
      .then(() => {
        setSubmitting(false);
        toast.success('User info successfully updated.');
      })
      .catch(response => {
        setSubmitting(false);
        setErrors(responseErrors(response));
      });
  },
  displayName: 'SupportInfoForm'
})(SupportInfoForm);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/components/SupportInfoForm.jsx